import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './ui/SectionHeading';
import { bonos } from '../data/landing';
export function Bonos() {
  return <section className="w-full bg-borgona py-12 sm:py-20" aria-labelledby="bonos-titulo" data-id="element-21" data-mp="2ldwqcqy8bafn">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-22" data-mp="2q5eqxdwcb903">
        <Reveal className="flex justify-center" data-id="element-23" data-mp="2q6zq5gtlng4a">
          <span className="inline-flex items-center gap-2 rounded-full bg-terracota px-4 py-2 font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-white sm:text-xs" data-id="element-24" data-mp="2v4rey1yy6m49">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="352fceznxu7q4" />
            Solo por hoy
          </span>
        </Reveal>

        <Reveal delay={0.05} className="mt-5" data-id="element-26" data-mp="3940x376prqav">
          <SectionHeading tone="light" title={<span id="bonos-titulo" data-id="element-28" data-mp="1aomqg6oigq18">
                Además, llevate 4 BONUS{' '}
                <em className="font-script not-italic text-rosa-200" data-id="element-29" data-mp="1epq3klf6c7yr">gratis</em>
              </span>} data-id="element-27" data-mp="391n0gtwdy617" />
        </Reveal>

        <div className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-6" data-id="element-30" data-mp="3e4j67yjr11f1">
          {bonos.map((bonus, index) => <Reveal key={bonus.numero} delay={0.05 * index} data-id="element-31" data-mp="39d11r0iioipb" data-mpi={index}>
              <article className="flex h-full overflow-hidden rounded-3xl bg-crema shadow-suave" data-id="element-32" data-mp="39bg5n6gk0rpc">
                <div className="w-2/5 shrink-0 bg-arena" data-id="element-33" data-mp="34bv72x5aqld5">
                  <img src={bonus.imagen} alt={`Portada del bonus ${bonus.titulo}`} loading="lazy" className="h-full w-full object-cover" data-id="element-34" data-mp="2zgfus9mxsxiu" />
                </div>
                <div className="flex flex-1 flex-col p-4 sm:p-6" data-id="element-35" data-mp="3s4213pnjug9e">
                  <span className="font-sans text-[11px] font-bold uppercase tracking-[0.18em] text-frambuesa" data-id="element-36" data-mp="3s1pirbdvq3vt">
                    {bonus.numero} · Gratis
                  </span>
                  <h3 className="mt-2 font-serif text-lg leading-snug text-borgona sm:text-2xl" data-id="element-37" data-mp="3i52yanpgteub">
                    {bonus.titulo}
                  </h3>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-suave sm:text-base" data-id="element-38" data-mp="26pxx5o4zfoct">
                    {bonus.descripcion}
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-39" data-mp="12s27yrb9h0e8">
          <p className="mt-8 text-center font-serif text-xl italic text-rosa-100 sm:text-2xl" data-id="element-40" data-mp="12q9d09a0g4m2">
            Incluidos HOY sin costo adicional.
          </p>
        </Reveal>
      </div>
    </section>;
}